import { profile, axiosConfig } from 'api';
import { AxiosResponse } from 'axios';

import { AdminUser } from 'models/adminUser';
import { Response } from 'models/response';
import { AccountResponse } from 'models/user';

export type TravelArrangerUsersAllowed = {
  id: string;
  userId: string;
  name: string;
  lastName: string;
  favorite: boolean;
  email: string;
  phoneNumber: string;
  userGroupName?: string;
  userGroupId?: string;
  guest?: boolean;
  birthDate: string;
  country: string;
  documentNumber: string;
  gender: 'Male' | 'Female';
  passportNumber?: string;
  loyaltyId?: string;
  loyaltyNumber?: string;
};

export const fetchUser = (id: string) =>
  profile.get<Response<AdminUser>>(`/users/${id}`, axiosConfig).then((response) => response.data.data);

export const fetchInvite = (id: string) =>
  profile.get<Response<AdminUser>>(`/invite/${id}`, axiosConfig).then((response) => response.data.data);

export const getAllowedTravelers = (): Promise<Response<TravelArrangerUsersAllowed[]>> =>
  profile
    .get<Response<TravelArrangerUsersAllowed[]>>('/Invite/GetAllUsersAndInvites/', axiosConfig)
    .then((response) => response.data)
    .catch((error) => error.data);

export const fetchAccount = (): Promise<AxiosResponse<Response<AccountResponse>>> =>
  profile.get('Users/GetMyAccount', axiosConfig);
